import useFadeIn from '../../hooks/useFadeIn';
import './Experience.css';

const roles = [
  {
    company: '3 Dogs Advisory',
    role: 'Founder & Principal Consultant',
    period: '2024 — Present',
    location: 'Holly Springs, NC',
    description:
      'Fractional CTO consulting for growth-stage companies — engineering org design, agile transformation, and AI-augmented delivery workflows.',
  },
  {
    company: 'Babyscripts',
    role: 'EVP of Technology',
    period: '2023 — 2025',
    location: 'Washington, DC (Remote)',
    description:
      'Led product and engineering for a maternal healthcare platform, building a remote engineering culture and driving the shift to a tech-enabled services organization.',
  },
  {
    company: 'ilumivu',
    role: 'SVP of Engineering',
    period: '2022 — 2023',
    location: 'Asheville, NC (Remote)',
    description:
      'Led product, engineering, and data science for behavioral health monitoring products. Built distributed teams across the U.S. and Costa Rica.',
  },
  {
    company: 'Validic',
    role: 'CTO / SVP of Technology',
    period: '2016 — 2022',
    location: 'Durham, NC',
    description:
      'Scaled engineering from 10 to 40 engineers. Architected next-generation RPM platform with EHR integrations and real-time data streaming.',
  },
  {
    company: 'Digital Turbine',
    role: 'VP, R&D',
    period: '2013 — 2016',
    location: 'Durham, NC',
    description:
      'Led global engineering across Software, DevOps, and IT. Managed the transition of core development from Israel to the U.S.',
  },
];

const Experience = () => {
  const [ref, isVisible] = useFadeIn();

  return (
    <section className="experience section" id="experience">
      <div className={`container fade-in ${isVisible ? 'visible' : ''}`} ref={ref}>
        <p className="section-eyebrow">Experience</p>
        <h2 className="section-heading experience__heading">Career Highlights</h2>
        <div className="timeline">
          {roles.map((role, i) => (
            <div className="timeline__item" key={i}>
              <div className="timeline__dot" />
              <div className="timeline__card">
                <span className="timeline__company">{role.company}</span>
                <h3 className="timeline__role">{role.role}</h3>
                <div className="timeline__meta">
                  <span>{role.period}</span>
                  <span className="timeline__sep">&middot;</span>
                  <span>{role.location}</span>
                </div>
                <p className="timeline__desc">{role.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
